export default "__VITE_ASSET__926d359d__"